﻿class FormatMoney extends HTMLElement {
  connectedCallback() {
    const currency = this.getAttribute('currency');
    const culture = this.getAttribute('culture');

    const formatter = new Intl.NumberFormat(culture, {
      style: 'currency',
      currency: currency,
    });
    const targetNode = this;
    this.innerText = formatter.format(this.innerText);
    const callback = (mutationList, observer) => {
      if (!isNaN(this.innerText)) {
        this.innerText = formatter.format(this.innerText);
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, { childList: true });
  }
}

customElements.define('format-money', FormatMoney);
